webpackJsonp([10],{

/***/ 1245:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BoxSection; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_css__ = __webpack_require__(1246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__styles_css__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var Box = function (_Component) {
  _inherits(Box, _Component);

  function Box() {
    _classCallCheck(this, Box);

    return _possibleConstructorReturn(this, (Box.__proto__ || Object.getPrototypeOf(Box)).apply(this, arguments));
  }

  _createClass(Box, [{
    key: 'getClassName',
    value: function getClassName() {
      return __WEBPACK_IMPORTED_MODULE_2_classnames___default()(__WEBPACK_IMPORTED_MODULE_3__styles_css___default.a.root, _defineProperty({}, __WEBPACK_IMPORTED_MODULE_3__styles_css___default.a.shadow, this.props.shadow), _defineProperty({}, __WEBPACK_IMPORTED_MODULE_3__styles_css___default.a.hidden, this.props.hidden), this.props.className);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          shadow = _props.shadow,
          restProps = _objectWithoutProperties(_props, ['children', 'shadow']);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        _extends({}, restProps, { className: this.getClassName() }),
        this.props.children
      );
    }
  }]);

  return Box;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Box.defaultProps = {
  className: '',
  shadow: false,
  hidden: false
};


var BoxSection = function BoxSection(_ref) {
  var className = _ref.className,
      children = _ref.children,
      disabled = _ref.disabled,
      disabledContent = _ref.disabledContent,
      restProps = _objectWithoutProperties(_ref, ['className', 'children', 'disabled', 'disabledContent']);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    _extends({}, restProps, { className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(__WEBPACK_IMPORTED_MODULE_3__styles_css___default.a.section, className) }),
    children,
    disabled && _jsx('div', {
      className: __WEBPACK_IMPORTED_MODULE_3__styles_css___default.a.disabledOverlay
    }, void 0, disabledContent)
  );
};

BoxSection.defaultProps = {
  className: '',
  disabled: false,
  disabledContent: null
};

/* harmony default export */ __webpack_exports__["b"] = (Box);


/***/ }),

/***/ 1246:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"root":"_1Ob7a","shadow":"_3NCC3","hidden":"_170VA","section":"UNjnV","disabledOverlay":"_2jdoD"};

/***/ }),

/***/ 1250:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Spinner__ = __webpack_require__(519);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Link__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_css__ = __webpack_require__(1252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__styles_css__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var _ref = _jsx(__WEBPACK_IMPORTED_MODULE_3_components_Spinner__["a" /* default */], {
  width: '30',
  height: '30',
  color: '#fff'
});

var Button = function (_Component) {
  _inherits(Button, _Component);

  function Button() {
    _classCallCheck(this, Button);

    return _possibleConstructorReturn(this, (Button.__proto__ || Object.getPrototypeOf(Button)).apply(this, arguments));
  }

  _createClass(Button, [{
    key: 'getElement',
    value: function getElement() {
      return 'href' in this.props ? __WEBPACK_IMPORTED_MODULE_4_components_Link__["a" /* default */] : 'button';
    }
  }, {
    key: 'getClassName',
    value: function getClassName() {
      var _classnames;

      return __WEBPACK_IMPORTED_MODULE_2_classnames___default()(__WEBPACK_IMPORTED_MODULE_5__styles_css___default.a.root, __WEBPACK_IMPORTED_MODULE_5__styles_css___default.a[this.props.theme], __WEBPACK_IMPORTED_MODULE_5__styles_css___default.a[this.props.size], (_classnames = {}, _defineProperty(_classnames, __WEBPACK_IMPORTED_MODULE_5__styles_css___default.a.rounded, this.props.rounded), _defineProperty(_classnames, __WEBPACK_IMPORTED_MODULE_5__styles_css___default.a.disabled, this.props.disabled), _defineProperty(_classnames, __WEBPACK_IMPORTED_MODULE_5__styles_css___default.a.loading, this.props.loading), _classnames), this.props.className);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          children = _props.children,
          theme = _props.theme,
          size = _props.size,
          rounded = _props.rounded,
          loading = _props.loading,
          restProps = _objectWithoutProperties(_props, ['className', 'children', 'theme', 'size', 'rounded', 'loading']);

      var Element = this.getElement();

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        Element,
        _extends({}, restProps, {
          disabled: this.props.disabled || this.props.loading,
          className: this.getClassName()
        }),
        loading && _jsx('span', {
          className: __WEBPACK_IMPORTED_MODULE_5__styles_css___default.a.spinnerWrapper
        }, void 0, _ref),
        _jsx('span', {
          className: __WEBPACK_IMPORTED_MODULE_5__styles_css___default.a.content
        }, void 0, children)
      );
    }
  }]);

  return Button;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Button.defaultProps = {
  className: '',
  theme: 'primary',
  size: 'medium',
  rounded: false,
  disabled: false,
  loading: false
};


/* harmony default export */ __webpack_exports__["a"] = (Button);

/***/ }),

/***/ 1252:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"root":"_3dLYL","primary":"_1YvH8","secondary":"_6JJ0o","small":"_3zJyZ","medium":"_2qrUQ","large":"_15GK-","full":"_3VCHy","rounded":"_2v4Pb","content":"_3CV4w","loading":"eWg_z","spinnerWrapper":"_3Ug5r"};

/***/ }),

/***/ 1259:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_css__ = __webpack_require__(1262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__styles_css__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var Distribute = function (_Component) {
  _inherits(Distribute, _Component);

  function Distribute() {
    _classCallCheck(this, Distribute);

    return _possibleConstructorReturn(this, (Distribute.__proto__ || Object.getPrototypeOf(Distribute)).apply(this, arguments));
  }

  _createClass(Distribute, [{
    key: 'getClassName',
    value: function getClassName() {
      return __WEBPACK_IMPORTED_MODULE_2_classnames___default()(__WEBPACK_IMPORTED_MODULE_3__styles_css___default.a.root, __WEBPACK_IMPORTED_MODULE_3__styles_css___default.a[this.props.direction], __WEBPACK_IMPORTED_MODULE_3__styles_css___default.a[this.props.size], _defineProperty({}, __WEBPACK_IMPORTED_MODULE_3__styles_css___default.a.equalHeight, this.props.equalHeight), this.props.className);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          direction = _props.direction,
          size = _props.size,
          equalHeight = _props.equalHeight,
          restProps = _objectWithoutProperties(_props, ['children', 'direction', 'size', 'equalHeight']);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        _extends({}, restProps, { className: this.getClassName() }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.map(children, function (child) {
          return child ? _jsx('div', {
            className: __WEBPACK_IMPORTED_MODULE_3__styles_css___default.a.child
          }, void 0, child) : null;
        })
      );
    }
  }]);

  return Distribute;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Distribute.defaultProps = {
  className: '',
  direction: 'row',
  size: 'medium',
  equalHeight: false
};


/* harmony default export */ __webpack_exports__["a"] = (Distribute);

/***/ }),

/***/ 1262:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"root":"_3G5Nu","row":"YFKO0","small":"_1Vnfv","medium":"_2HJ1j","large":"KtknO","child":"_3gHnX","equalHeight":"QItAK"};

/***/ }),

/***/ 1277:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_tag_autocomplete__ = __webpack_require__(1278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_tag_autocomplete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_tag_autocomplete__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_css__ = __webpack_require__(1282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__styles_css__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var Tag = function Tag(_ref) {
  var classNames = _ref.classNames,
      onDelete = _ref.onDelete,
      tag = _ref.tag;
  return _jsx('div', {
    className: classNames.selectedTag,
    title: 'Click to remove tag',
    onClick: onDelete,
    role: 'button'
  }, void 0, _jsx('span', {
    className: classNames.selectedTagName
  }, void 0, tag.name));
};

/**
 * For all available options see plugin documentation
 * @link https://github.com/i-like-robots/react-tags
 */

var Search = function (_Component) {
  _inherits(Search, _Component);

  function Search(props) {
    _classCallCheck(this, Search);

    var _this = _possibleConstructorReturn(this, (Search.__proto__ || Object.getPrototypeOf(Search)).call(this, props));

    _this.onAdd = function (tag) {
      var value = _this.getValue();
      var tags = [].concat(_toConsumableArray(new Set([].concat(value, tag))));
      _this.props.onChange(tags);
    };

    _this.onDelete = function (index) {
      var value = _this.getValue();
      if (value.length) {
        value.splice(index, 1);
        _this.props.onChange(value);
      }
    };

    _this.state = {
      suggestions: []
    };
    return _this;
  }

  _createClass(Search, [{
    key: 'onInputChange',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(input) {
        var _props, keyFunc, suggestions, value, results, keys, diff;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _props = this.props, keyFunc = _props.keyFunc, suggestions = _props.suggestions;
                value = this.getValue();

                if (input) {
                  _context.next = 4;
                  break;
                }

                return _context.abrupt('return');

              case 4:
                _context.next = 6;
                return suggestions(input);

              case 6:
                results = _context.sent;
                keys = value.map(keyFunc);
                diff = results.filter(function (tag) {
                  return keys.indexOf(keyFunc(tag)) === -1;
                });


                this.setState({ suggestions: [].concat(_toConsumableArray(diff)) });

              case 10:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function onInputChange(_x) {
        return _ref2.apply(this, arguments);
      }

      return onInputChange;
    }()
  }, {
    key: 'getValue',
    value: function getValue() {
      return this.props.value || [];
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          className = _props2.className,
          label = _props2.label,
          placeholder = _props2.placeholder,
          single = _props2.single,
          restProps = _objectWithoutProperties(_props2, ['className', 'label', 'placeholder', 'single']);

      var value = this.getValue();

      return _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(__WEBPACK_IMPORTED_MODULE_4__styles_css___default.a.root, className, _defineProperty({}, __WEBPACK_IMPORTED_MODULE_4__styles_css___default.a.hideInput, single && (value || []).length > 0))
      }, void 0, label && _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_4__styles_css___default.a.label
      }, void 0, label), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_tag_autocomplete___default.a, _extends({
        autofocus: false,
        autoresize: false,
        tagComponent: Tag
      }, restProps, {
        suggestions: this.state.suggestions,
        tags: value,
        placeholder: placeholder,
        handleAddition: this.onAdd,
        handleDelete: this.onDelete,
        handleInputChange: this.onInputChange.bind(this)
      })));
    }
  }]);

  return Search;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Search.defaultProps = {
  className: '',
  label: '',
  suggestions: [],
  value: [],
  placeholder: '',
  keyFunc: function keyFunc(x) {
    return x;
  },
  onChange: function onChange(tags) {
    return console.log('tags updated:', tags);
  },
  single: false
};


/* harmony default export */ __webpack_exports__["a"] = (Search);

/***/ }),

/***/ 1278:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(2)
var PropTypes = __webpack_require__(4)
var Tag = __webpack_require__(1279)
var Input = __webpack_require__(1280)
var Suggestions = __webpack_require__(1281)

var KEYS = {
  ENTER: 13,
  TAB: 9,
  BACKSPACE: 8,
  UP_ARROW: 38,
  DOWN_ARROW: 40
}

var CLASS_NAMES = {
  root: 'react-tags',
  rootFocused: 'is-focused',
  selected: 'react-tags__selected',
  selectedTag: 'react-tags__selected-tag',
  selectedTagName: 'react-tags__selected-tag-name',
  search: 'react-tags__search',
  searchInput: 'react-tags__search-input',
  suggestions: 'react-tags__suggestions',
  suggestionActive: 'is-active',
  suggestionDisabled: 'is-disabled'
}

var ReactTags = (function (superclass) {
  function ReactTags (props) {
    superclass.call(this, props)

    this.state = {
      query: '',
      focused: false,
      expandable: false,
      selectedIndex: -1,
      classNames: Object.assign({}, CLASS_NAMES, this.props.classNames)
    }
  }

  if ( superclass ) ReactTags.__proto__ = superclass;
  ReactTags.prototype = Object.create( superclass && superclass.prototype );
  ReactTags.prototype.constructor = ReactTags;

  ReactTags.prototype.componentWillReceiveProps = function componentWillReceiveProps (newProps) {
    this.setState({
      classNames: Object.assign({}, CLASS_NAMES, newProps.classNames)
    })
  };

  ReactTags.prototype.handleInput = function handleInput (e) {
    var query = e.target.value

    if (this.props.handleInputChange) {
      this.props.handleInputChange(query)
    }

    this.setState({ query: query })
  };

  ReactTags.prototype.handleKeyDown = function handleKeyDown (e) {
    var ref = this.state;
    var query = ref.query;
    var selectedIndex = ref.selectedIndex;
    var ref$1 = this.props;
    var delimiters = ref$1.delimiters;
    var delimiterChars = ref$1.delimiterChars;

    // when one of the terminating keys is pressed, add current query to the tags.
    if (delimiters.indexOf(e.keyCode) > -1 || delimiterChars.indexOf(e.key) > -1) {
      if (query || selectedIndex > -1) {
        e.preventDefault()
      }

      if (query.length >= this.props.minQueryLength) {
        // Check if the user typed in an existing suggestion.
        var match = this.suggestions.state.options.findIndex(function (suggestion) {
          return suggestion.name.search(new RegExp(("^" + query + "$"), 'i')) === 0
        })

        var index = selectedIndex === -1 ? match : selectedIndex

        if (index > -1) {
          this.addTag(this.suggestions.state.options[index])
        } else if (this.props.allowNew) {
          this.addTag({ name: query })
        }
      }
    }

    // when backspace key is pressed and query is blank, delete the last tag
    if (e.keyCode === KEYS.BACKSPACE && query.length === 0 && this.props.allowBackspace) {
      this.deleteTag(this.props.tags.length - 1)
    }

    if (e.keyCode === KEYS.UP_ARROW) {
      e.preventDefault()

      // if last item, cycle to the bottom
      if (selectedIndex <= 0) {
        this.setState({ selectedIndex: this.suggestions.state.options.length - 1 })
      } else {
        this.setState({ selectedIndex: selectedIndex - 1 })
      }
    }

    if (e.keyCode === KEYS.DOWN_ARROW) {
      e.preventDefault()

      this.setState({ selectedIndex: (selectedIndex + 1) % this.suggestions.state.options.length })
    }
  };

  ReactTags.prototype.handleClick = function handleClick (e) {
    if (document.activeElement !== e.target) {
      this.input.input.focus()
    }
  };

  ReactTags.prototype.handleBlur = function handleBlur () {
    this.setState({ focused: false, selectedIndex: -1 })

    if (this.props.handleBlur) {
      this.props.handleBlur()
    }
  };

  ReactTags.prototype.handleFocus = function handleFocus () {
    this.setState({ focused: true })

    if (this.props.handleFocus) {
      this.props.handleFocus()
    }
  };

  ReactTags.prototype.addTag = function addTag (tag) {
    if (tag.disabled) {
      return
    }

    this.props.handleAddition(tag)

    // reset the state
    this.setState({
      query: '',
      selectedIndex: -1
    })
  };

  ReactTags.prototype.deleteTag = function deleteTag (i) {
    this.props.handleDelete(i)
    this.setState({ query: '' })
  };

  ReactTags.prototype.render = function render () {
    var this$1 = this;

    var listboxId = 'ReactTags-listbox'

    var TagComponent = this.props.tagComponent || Tag

    var tags = this.props.tags.map(function (tag, i) { return (
      React.createElement( TagComponent, {
        key: i, tag: tag, classNames: this$1.state.classNames, onDelete: this$1.deleteTag.bind(this$1, i) })
    ); })

    var expandable = this.state.focused && this.state.query.length >= this.props.minQueryLength
    var classNames = [this.state.classNames.root]

    this.state.focused && classNames.push(this.state.classNames.rootFocused)

    return (
      React.createElement( 'div', { className: classNames.join(' '), onClick: this.handleClick.bind(this) },
        React.createElement( 'div', { className: this.state.classNames.selected, 'aria-live': 'polite', 'aria-relevant': 'additions removals' },
          tags
        ),
        React.createElement( 'div', {
          className: this.state.classNames.search, onBlurCapture: this.handleBlur.bind(this), onFocusCapture: this.handleFocus.bind(this), onInput: this.handleInput.bind(this), onKeyDown: this.handleKeyDown.bind(this) },
          React.createElement( Input, Object.assign({}, this.state, { ref: function (c) { this$1.input = c }, listboxId: listboxId, autofocus: this.props.autofocus, autoresize: this.props.autoresize, expandable: expandable, placeholder: this.props.placeholder })),
          React.createElement( Suggestions, Object.assign({}, this.state, { ref: function (c) { this$1.suggestions = c }, listboxId: listboxId, expandable: expandable, suggestions: this.props.suggestions, addTag: this.addTag.bind(this), maxSuggestionsLength: this.props.maxSuggestionsLength }))
        )
      )
    )
  };

  return ReactTags;
}(React.Component));

ReactTags.defaultProps = {
  tags: [],
  placeholder: 'Add new tag',
  suggestions: [],
  autofocus: true,
  autoresize: true,
  delimiters: [KEYS.TAB, KEYS.ENTER],
  delimiterChars: [],
  minQueryLength: 2,
  maxSuggestionsLength: 6,
  allowNew: false,
  allowBackspace: true,
  tagComponent: null
}

ReactTags.propTypes = {
  tags: PropTypes.arrayOf(PropTypes.object),
  placeholder: PropTypes.string,
  suggestions: PropTypes.arrayOf(PropTypes.object),
  autofocus: PropTypes.bool,
  autoresize: PropTypes.bool,
  delimiters: PropTypes.arrayOf(PropTypes.number),
  delimiterChars: PropTypes.arrayOf(PropTypes.string),
  handleDelete: PropTypes.func.isRequired,
  handleAddition: PropTypes.func.isRequired,
  handleInputChange: PropTypes.func,
  handleFocus: PropTypes.func,
  handleBlur: PropTypes.func,
  minQueryLength: PropTypes.number,
  maxSuggestionsLength: PropTypes.number,
  classNames: PropTypes.object,
  allowNew: PropTypes.bool,
  allowBackspace: PropTypes.bool,
  tagComponent: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.element
  ])
}

module.exports = ReactTags


/***/ }),

/***/ 1279:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(2)

module.exports = function (props) { return (
  React.createElement( 'button', { type: 'button', className: props.classNames.selectedTag, title: 'Click to remove tag', onClick: props.onDelete },
    React.createElement( 'span', { className: props.classNames.selectedTagName }, props.tag.name)
  )
); }


/***/ }),

/***/ 1280:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(2)

var SIZER_STYLES = {
  position: 'absolute',
  width: 0,
  height: 0,
  visibility: 'hidden',
  overflow: 'scroll',
  whiteSpace: 'pre'
}

var STYLE_PROPS = [
  'fontSize',
  'fontFamily',
  'fontWeight',
  'fontStyle',
  'letterSpacing'
]

var Input = (function (superclass) {
  function Input (props) {
    superclass.call(this, props)
    this.state = { inputWidth: null }
  }

  if ( superclass ) Input.__proto__ = superclass;
  Input.prototype = Object.create( superclass && superclass.prototype );
  Input.prototype.constructor = Input;

  Input.prototype.componentDidMount = function componentDidMount () {
    if (this.props.autoresize) {
      this.copyInputStyles()
      this.updateInputWidth()
    }

    if (this.props.autofocus) {
      this.input.focus()
    }
  };

  Input.prototype.componentDidUpdate = function componentDidUpdate (prevProps) {
    this.updateInputWidth()
  };

  Input.prototype.componentWillReceiveProps = function componentWillReceiveProps (newProps) {
    if (this.input.value !== newProps.query) {
      this.input.value = newProps.query
    }
  };

  Input.prototype.copyInputStyles = function copyInputStyles () {
    var this$1 = this;

    var inputStyle = window.getComputedStyle(this.input)

    STYLE_PROPS.forEach(function (prop) {
      this$1.sizer.style[prop] = inputStyle[prop]
    })
  };

  Input.prototype.updateInputWidth = function updateInputWidth () {
    var inputWidth

    if (this.props.autoresize) {
      // scrollWidth is designed to be fast not accurate.
      // +2 is completely arbitrary but does the job.
      inputWidth = Math.ceil(this.sizer.scrollWidth) + 2
    }

    if (inputWidth !== this.state.inputWidth) {
      this.setState({ inputWidth: inputWidth })
    }
  };

  Input.prototype.render = function render () {
    var this$1 = this;

    var ref = this.props;
    var query = ref.query;
    var placeholder = ref.placeholder;
    var expandable = ref.expandable;
    var listboxId = ref.listboxId;
    var selectedIndex = ref.selectedIndex;

    return (
      React.createElement( 'div', { className: this.props.classNames.searchInput },
        React.createElement( 'input', {
          ref: function (c) { this$1.input = c }, value: query, placeholder: placeholder, role: 'combobox', 'aria-autocomplete': 'list', 'aria-label': placeholder, 'aria-owns': listboxId, 'aria-activedescendant': selectedIndex > -1 ? (listboxId + "-" + selectedIndex) : null, 'aria-expanded': expandable, style: { width: this.state.inputWidth } }),
        React.createElement( 'div', { ref: function (c) { this$1.sizer = c }, style: SIZER_STYLES }, query || placeholder)
      )
    )
  };

  return Input;
}(React.Component));

module.exports = Input


/***/ }),

/***/ 1281:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(2)

function escapeForRegExp (query) {
  return query.replace(/[-\\^$*+?.()|[\]{}]/g, '\\$&')
}

function markIt (input, query) {
  var regex = RegExp(escapeForRegExp(query), 'gi')

  return {
    __html: input.replace(regex, '<mark>$&</mark>')
  }
}

function filterSuggestions (query, suggestions, length) {
  var regex = new RegExp(("(?:^|\\s)" + (escapeForRegExp(query))), 'i')
  return suggestions.filter(function (item) { return regex.test(item.name); }).slice(0, length)
}

var Suggestions = (function (superclass) {
  function Suggestions (props) {
    superclass.call(this, props)

    this.state = {
      options: filterSuggestions(this.props.query, this.props.suggestions, this.props.maxSuggestionsLength)
    }
  }

  if ( superclass ) Suggestions.__proto__ = superclass;
  Suggestions.prototype = Object.create( superclass && superclass.prototype );
  Suggestions.prototype.constructor = Suggestions;

  Suggestions.prototype.componentWillReceiveProps = function componentWillReceiveProps (newProps) {
    this.setState({
      options: filterSuggestions(newProps.query, newProps.suggestions, newProps.maxSuggestionsLength)
    })
  };

  Suggestions.prototype.handleMouseDown = function handleMouseDown (item, e) {
    // focus is shifted on mouse down but calling preventDefault prevents this
    e.preventDefault()
    this.props.addTag(item)
  };

  Suggestions.prototype.render = function render () {
    var this$1 = this;

    if (!this.props.expandable || !this.state.options.length) {
      return null
    }

    var options = this.state.options.map(function (item, i) {
      var key = (this$1.props.listboxId) + "-" + i
      var classNames = []

      if (this$1.props.selectedIndex === i) {
        classNames.push(this$1.props.classNames.suggestionActive)
      }

      if (item.disabled) {
        classNames.push(this$1.props.classNames.suggestionDisabled)
      }

      return (
        React.createElement( 'li', {
          id: key, key: key, role: 'option', className: classNames.join(' '), 'aria-disabled': item.disabled === true, onMouseDown: this$1.handleMouseDown.bind(this$1, item) },
          React.createElement( 'span', { dangerouslySetInnerHTML: markIt(item.name, this$1.props.query) })
        )
      )
    })

    return (
      React.createElement( 'div', { className: this.props.classNames.suggestions },
        React.createElement( 'ul', { role: 'listbox', id: this.props.listboxId }, options)
      )
    )
  };

  return Suggestions;
}(React.Component));

module.exports = Suggestions


/***/ }),

/***/ 1282:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"root":"_351Ye","label":"_1ipwX","hideInput":"_1ix_F"};

/***/ }),

/***/ 1633:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_css__ = __webpack_require__(1634);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__styles_css__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var StoryCarousel = function (_Component) {
  _inherits(StoryCarousel, _Component);

  function StoryCarousel(props) {
    _classCallCheck(this, StoryCarousel);

    var _this = _possibleConstructorReturn(this, (StoryCarousel.__proto__ || Object.getPrototypeOf(StoryCarousel)).call(this, props));

    _this.state = {
      active: Math.floor(props.stories.length / 2)
    };
    return _this;
  }

  _createClass(StoryCarousel, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      this.timer = setInterval(function () {
        _this2.setState(function (prevState, props) {
          return {
            active: (prevState.active + 1) % props.stories.length
          };
        });
      }, this.props.frequence);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps() {
      this.setState({ active: 0 });
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearInterval(this.timer);
    }
  }, {
    key: 'getClassName',
    value: function getClassName() {
      return __WEBPACK_IMPORTED_MODULE_2_classnames___default()(__WEBPACK_IMPORTED_MODULE_3__styles_css___default.a.root, this.props.className);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          className = _props.className,
          stories = _props.stories,
          restProps = _objectWithoutProperties(_props, ['className', 'stories']);

      var active = this.state.active;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        _extends({ className: this.getClassName() }, restProps),
        _jsx('div', {
          className: __WEBPACK_IMPORTED_MODULE_3__styles_css___default.a.bubble
        }, void 0, stories.map(function (_ref, index) {
          var story = _ref.story;
          return (
            // Render all stories and hide the non-active ones with
            // CSS so that all of the Djedi nodes always appear in
            // the Djedi sidebar.
            _jsx('blockquote', {
              className: __WEBPACK_IMPORTED_MODULE_3__styles_css___default.a.quote,
              hidden: index !== active
            }, index, story)
          );
        })),
        _jsx('div', {
          className: __WEBPACK_IMPORTED_MODULE_3__styles_css___default.a.heads
        }, void 0, stories.map(function (_ref2, i) {
          var picture = _ref2.picture;
          return _jsx('div', {
            className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(__WEBPACK_IMPORTED_MODULE_3__styles_css___default.a.head, _defineProperty({}, __WEBPACK_IMPORTED_MODULE_3__styles_css___default.a.active, active === i)),
            onClick: function onClick() {
              clearInterval(_this3.timer);
              _this3.setState({ active: i });
            },
            role: 'radio'
          }, i, _jsx('div', {
            className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(__WEBPACK_IMPORTED_MODULE_3__styles_css___default.a.triangle, _defineProperty({}, __WEBPACK_IMPORTED_MODULE_3__styles_css___default.a.hidden, active !== i))
          }), _jsx('div', {
            className: __WEBPACK_IMPORTED_MODULE_3__styles_css___default.a.pictureWrapper
          }, void 0, _jsx('img', {
            src: picture,
            alt: '',
            className: __WEBPACK_IMPORTED_MODULE_3__styles_css___default.a.picture
          })));
        }))
      );
    }
  }]);

  return StoryCarousel;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

StoryCarousel.defaultProps = {
  className: '',
  frequence: 20000
};


/* harmony default export */ __webpack_exports__["a"] = (StoryCarousel);

/***/ }),

/***/ 1634:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"root":"_3N8lg","bubble":"euMzf","quote":"_1NYnu","heads":"_2cKel","head":"_2kXLg","active":"_3kh_X","picture":"_2lFdg","triangle":"LT5UX","hidden":"t3qCS","pictureWrapper":"Ob9Nu"};

/***/ }),

/***/ 1635:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_css__ = __webpack_require__(1636);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_svgs_breakit_logo_white_svg__ = __webpack_require__(1637);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_svgs_breakit_logo_white_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_svgs_breakit_logo_white_svg__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();





var BreakitBanner = function BreakitBanner() {
  return _jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_1__styles_css___default.a.container
  }, void 0, _jsx('span', {
    className: __WEBPACK_IMPORTED_MODULE_1__styles_css___default.a.text
  }, void 0, '\u201DDe ritar om marknaden f\xF6r fritidsaktiviteter\u201D'), _jsx('img', {
    className: __WEBPACK_IMPORTED_MODULE_1__styles_css___default.a.logo,
    src: __WEBPACK_IMPORTED_MODULE_2__assets_svgs_breakit_logo_white_svg___default.a,
    alt: 'Breakit logo'
  }));
};

/* harmony default export */ __webpack_exports__["a"] = (BreakitBanner);

/***/ }),

/***/ 1636:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_2LW0h","logo":"_3wLAa","text":"dUlfG"};

/***/ }),

/***/ 1637:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/breakit-logo-white.6863caa1.svg";

/***/ }),

/***/ 1638:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/student-lydia.a847bc7f.jpg";

/***/ }),

/***/ 1639:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/student-emil.060b6431.jpg";

/***/ }),

/***/ 1640:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/student-leonie.2217bc46.jpg";

/***/ }),

/***/ 1641:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/student-sara.5593db5e.jpg";

/***/ }),

/***/ 1642:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/foralder-karin-stockholm.9bce29b5.jpg";

/***/ }),

/***/ 1643:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/foralder-malin-stockholm.6e9c3655.jpg";

/***/ }),

/***/ 1644:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/foralder-susanne-stockholm.29b75cc9.jpg";

/***/ }),

/***/ 1645:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"root":"h07xz","hero":"_11Q1c","heroContainer":"_2Ac_E","heroTitle":"RPGRV","heroPreamble":"_bRUG","spacer":"_2QsQD","search":"_22Dya","searchButton":"_1tedJ","searchInput":"_10c5q","boxes":"_2js7g","footer":"_2ru3O","uspIcon":"_1vxFK","blue":"MIwGe","orange":"_1mx36","green":"_1YhGJ","imageWrapper":"_3vfT0","boxImage":"_2a_eV","compactBox":"YSHkG","storyWrapper":"_2zj3g","link":"_3U4ht"};

/***/ }),

/***/ 556:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_djedi_react__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_djedi_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_djedi_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__fortawesome_react_fontawesome__ = __webpack_require__(526);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__fortawesome_react_fontawesome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__fortawesome_react_fontawesome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_layouts_Page__ = __webpack_require__(520);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_layouts_Container__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_layouts_Distribute__ = __webpack_require__(1259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_layouts_Box__ = __webpack_require__(1245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_Search__ = __webpack_require__(1277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_Button__ = __webpack_require__(1250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_StoryCarousel__ = __webpack_require__(1633);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_BreakitBanner__ = __webpack_require__(1635);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_api__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_utilities_routes__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_views_FindActivity_constants__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_assets_homepage_student_lydia_jpg__ = __webpack_require__(1638);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_assets_homepage_student_lydia_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_assets_homepage_student_lydia_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_assets_homepage_student_emil_jpg__ = __webpack_require__(1639);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_assets_homepage_student_emil_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_assets_homepage_student_emil_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_assets_homepage_student_leonie_jpg__ = __webpack_require__(1640);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_assets_homepage_student_leonie_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_assets_homepage_student_leonie_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_assets_homepage_student_sara_jpg__ = __webpack_require__(1641);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_assets_homepage_student_sara_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_assets_homepage_student_sara_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_assets_homepage_foralder_karin_stockholm_jpg__ = __webpack_require__(1642);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_assets_homepage_foralder_karin_stockholm_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_assets_homepage_foralder_karin_stockholm_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_assets_homepage_foralder_malin_stockholm_jpg__ = __webpack_require__(1643);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_assets_homepage_foralder_malin_stockholm_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_assets_homepage_foralder_malin_stockholm_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_assets_homepage_foralder_susanne_stockholm_jpg__ = __webpack_require__(1644);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_assets_homepage_foralder_susanne_stockholm_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_assets_homepage_foralder_susanne_stockholm_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_components_Link__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_views_ActivitiesAndSchools_constants__ = __webpack_require__(528);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__styles_css__ = __webpack_require__(1645);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__styles_css__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n                      ###Ett unikt utbud d\xE4r alla kan hitta sin aktivitet och sitt sammanhang\n\n                      V\xE5ra ledare har olika intressen och kompetenser i allt fr\xE5n skol\xE4mnen,\n                      musik, spr\xE5k programmering till bakning, teater och schack.\n                      Hitta en aktivitet som passar just ditt barn kring ett intresse,\n                      eller varf\xF6r inte kombinera tv\xE5? T.ex. baka p\xE5 engelska eller\n                      ha matte och schack under samma tillf\xE4lle.\n                    '], ['\n                      ###Ett unikt utbud d\xE4r alla kan hitta sin aktivitet och sitt sammanhang\n\n                      V\xE5ra ledare har olika intressen och kompetenser i allt fr\xE5n skol\xE4mnen,\n                      musik, spr\xE5k programmering till bakning, teater och schack.\n                      Hitta en aktivitet som passar just ditt barn kring ett intresse,\n                      eller varf\xF6r inte kombinera tv\xE5? T.ex. baka p\xE5 engelska eller\n                      ha matte och schack under samma tillf\xE4lle.\n                    ']),
    _templateObject2 = _taggedTemplateLiteral(['\n                      ###Tryggt och s\xE4kert\n\n                      V\xE5ra ledare \xE4r anst\xE4llda av Friendtivity AB\n                      och har alla passerat en gedigen rekryteringsprocess.\n                      Givetvis har vi n\xF6jdhetsgaranti vilket inneb\xE4r att\n                      du f\xE5r tillbaka dina pengar efter f\xF6rsta tillf\xE4llet\n                      ifall du av n\xE5gon anledning inte \xE4r n\xF6jd.\n                    '], ['\n                      ###Tryggt och s\xE4kert\n\n                      V\xE5ra ledare \xE4r anst\xE4llda av Friendtivity AB\n                      och har alla passerat en gedigen rekryteringsprocess.\n                      Givetvis har vi n\xF6jdhetsgaranti vilket inneb\xE4r att\n                      du f\xE5r tillbaka dina pengar efter f\xF6rsta tillf\xE4llet\n                      ifall du av n\xE5gon anledning inte \xE4r n\xF6jd.\n                    ']),
    _templateObject3 = _taggedTemplateLiteral(['\n                      ###Flexibelt och h\xE4mtning ing\xE5r\n\n                      Du skapar din egen grupp och best\xE4mmer\n                      sj\xE4lv var, n\xE4r och hur l\xE4nge aktiviteten\n                      ska p\xE5g\xE5 och vilka som \xE4r med. Sj\xE4lvklart\n                      h\xE4mtar v\xE5ra ledare era barn vid skolan\n                      om ni vill. Vill du ha en aktivitet enbart\n                      f\xF6r ditt barn s\xE5 g\xE5r det lika bra.\n                    '], ['\n                      ###Flexibelt och h\xE4mtning ing\xE5r\n\n                      Du skapar din egen grupp och best\xE4mmer\n                      sj\xE4lv var, n\xE4r och hur l\xE4nge aktiviteten\n                      ska p\xE5g\xE5 och vilka som \xE4r med. Sj\xE4lvklart\n                      h\xE4mtar v\xE5ra ledare era barn vid skolan\n                      om ni vill. Vill du ha en aktivitet enbart\n                      f\xF6r ditt barn s\xE5 g\xE5r det lika bra.\n                    ']),
    _templateObject4 = _taggedTemplateLiteral(['\n                        Nu beh\xF6ver jag inte stressa till h\xE4mtning, utan med friendtivity\n                        s\xE5 kan mitt barn och ett par av deras kompisar bli h\xE4mtade direkt fr\xE5n\n                        skolan och f\xE5 tillbringa eftermiddagen p\xE5 ett meningsfullt s\xE4tt genom att\n                        i ett avslappnat format l\xE4ra sig tex gitarr, schack, bakning med en h\xE4rlig\n                        och duktig friendtivity ledare. Och kanske \xE4ven ha aktiviteten p\xE5 ett nytt spr\xE5k.\n\n                        Susanne, Stockholm\n                      '], ['\n                        Nu beh\xF6ver jag inte stressa till h\xE4mtning, utan med friendtivity\n                        s\xE5 kan mitt barn och ett par av deras kompisar bli h\xE4mtade direkt fr\xE5n\n                        skolan och f\xE5 tillbringa eftermiddagen p\xE5 ett meningsfullt s\xE4tt genom att\n                        i ett avslappnat format l\xE4ra sig tex gitarr, schack, bakning med en h\xE4rlig\n                        och duktig friendtivity ledare. Och kanske \xE4ven ha aktiviteten p\xE5 ett nytt spr\xE5k.\n\n                        Susanne, Stockholm\n                      ']),
    _templateObject5 = _taggedTemplateLiteral(['\n                        Jag ser fram emot att kunna hitta bra fritidsaktivieter f\xF6r mina barn i v\xE5rt n\xE4romr\xE5de\n                        utan att beh\xF6va planera j\xE4ttel\xE5ng tid i f\xF6rv\xE4g. Kul att t.ex. kunna prova en 4 veckors\n                        aktivitet mitt i terminen.\n\n                        Karin, Stockholm\n                      '], ['\n                        Jag ser fram emot att kunna hitta bra fritidsaktivieter f\xF6r mina barn i v\xE5rt n\xE4romr\xE5de\n                        utan att beh\xF6va planera j\xE4ttel\xE5ng tid i f\xF6rv\xE4g. Kul att t.ex. kunna prova en 4 veckors\n                        aktivitet mitt i terminen.\n\n                        Karin, Stockholm\n                      ']),
    _templateObject6 = _taggedTemplateLiteral(['\n                        Sp\xE4nnande nytt koncept som \xF6ppnar upp m\xF6jligheter att delta i fritidsaktiviteter\n                        som verkligen passar mitt barn. Att aktiviteterna sker i hemmet i en liten grupp om max\n                        fyra k\xE4nns ocks\xE5 tryggt och bra.\n\n                        Malin, Stockholm\n                      '], ['\n                        Sp\xE4nnande nytt koncept som \xF6ppnar upp m\xF6jligheter att delta i fritidsaktiviteter\n                        som verkligen passar mitt barn. Att aktiviteterna sker i hemmet i en liten grupp om max\n                        fyra k\xE4nns ocks\xE5 tryggt och bra.\n\n                        Malin, Stockholm\n                      ']),
    _templateObject7 = _taggedTemplateLiteral(['\n                      **Lydia, 20 \xE5r**\n\n                      KTH-student (Ind. ek.) och fantastisk fotograf\n                    '], ['\n                      **Lydia, 20 \xE5r**\n\n                      KTH-student (Ind. ek.) och fantastisk fotograf\n                    ']),
    _templateObject8 = _taggedTemplateLiteral(['\n                      **Emil, 19 \xE5r**\n\n                      KTH-student (Ind. ek.), med fokus p\xE5 mattegrupper.\n                    '], ['\n                      **Emil, 19 \xE5r**\n\n                      KTH-student (Ind. ek.), med fokus p\xE5 mattegrupper.\n                    ']),
    _templateObject9 = _taggedTemplateLiteral(['\n                      **Leonie, 21 \xE5r**\n\n                      S\xF6dert\xF6rns H\xF6gskola, tysktalande med fokus p\xE5 kreativt skapande.\n                    '], ['\n                      **Leonie, 21 \xE5r**\n\n                      S\xF6dert\xF6rns H\xF6gskola, tysktalande med fokus p\xE5 kreativt skapande.\n                    ']),
    _templateObject10 = _taggedTemplateLiteral(['\n                      **Sara, 23 \xE5r**\n\n                      KTH-student med fokus p\xE5 kreativa grupper inom programmering och matte.\n                    '], ['\n                      **Sara, 23 \xE5r**\n\n                      KTH-student med fokus p\xE5 kreativa grupper inom programmering och matte.\n                    ']);

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }


































var _ref2 = _jsx(__WEBPACK_IMPORTED_MODULE_0_djedi_react__["Node"], {
  uri: 'home/hero/title'
}, void 0, 'Hitta roliga och utvecklande fritidsaktiviteter!');

var _ref3 = _jsx(__WEBPACK_IMPORTED_MODULE_0_djedi_react__["Node"], {
  uri: 'home/hero/preamble'
}, void 0, 'Vi erbjuder fritidsaktiviteter p\xE5 ett nytt s\xE4tt - i sm\xE5 grupper i hemmet med en av v\xE5ra anst\xE4llda ledare. L\xE5t ditt barn utvecklas och inspireras att l\xE4ra mer kring t.ex. ett skol\xE4mne eller varf\xF6r inte uppt\xE4cka ett nytt intresse som t.ex. programmering, spr\xE5k, schack, teater, bakning eller n\xE5got helt annat. Aktiviteterna kan ske efter skolan, p\xE5 helgen, eller loven med nya och gamla kompisar.');

var _ref4 = _jsx('h2', {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_0_djedi_react__["Node"], {
  uri: 'home/heading1'
}, void 0, 'Marknadens schysstaste pris (fr. 95 kr/tim per deltagare) med n\xF6jdhetsgaranti'));

var _ref5 = _jsx('h2', {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_0_djedi_react__["Node"], {
  uri: 'home/heading2'
}, void 0, 'L\xE4s vad andra f\xF6r\xE4ldrar s\xE4ger om friendtivity'));

var _ref6 = _jsx('h2', {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_0_djedi_react__["Node"], {
  uri: 'home/heading3'
}, void 0, 'M\xF6t n\xE5gra av v\xE5ra ledare'));

var _ref7 = _jsx(__WEBPACK_IMPORTED_MODULE_13_components_BreakitBanner__["a" /* default */], {});

var HomePage = function (_Component) {
  _inherits(HomePage, _Component);

  function HomePage() {
    _classCallCheck(this, HomePage);

    return _possibleConstructorReturn(this, (HomePage.__proto__ || Object.getPrototypeOf(HomePage)).apply(this, arguments));
  }

  _createClass(HomePage, [{
    key: 'onSearch',
    value: function onSearch(tags) {
      var dispatch = this.props.dispatch;

      dispatch(Object(__WEBPACK_IMPORTED_MODULE_15_utilities_routes__["c" /* reverse */])(__WEBPACK_IMPORTED_MODULE_16_views_FindActivity_constants__["a" /* NAME */], {
        query: { tag: tags.length > 0 ? tags[0].name : undefined }
      }));
    }
  }, {
    key: 'suggest',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(input) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt('return', __WEBPACK_IMPORTED_MODULE_14_api__["a" /* default */].search.suggest(input));

              case 1:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function suggest(_x) {
        return _ref.apply(this, arguments);
      }

      return suggest;
    }()
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      //
      return _jsx(__WEBPACK_IMPORTED_MODULE_6_layouts_Page__["a" /* default */]
      // {...this.props.meta.toJS()}
      , {
        className: __WEBPACK_IMPORTED_MODULE_26__styles_css___default.a.root,
        description: 'Jag vill tipsa om friendtivity om du letar fritidsaktiviteter f\xF6r dina barn. G\xE5 in p\xE5 friendtivity.se'
      }, void 0, _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_26__styles_css___default.a.hero
      }, void 0, _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_26__styles_css___default.a.heroContainer
      }, void 0, _jsx('h1', {
        className: __WEBPACK_IMPORTED_MODULE_26__styles_css___default.a.heroTitle
      }, void 0, _ref2), _jsx('p', {
        className: __WEBPACK_IMPORTED_MODULE_26__styles_css___default.a.heroPreamble
      }, void 0, _ref3), _jsx('form', {
        method: 'post',
        onSubmit: function onSubmit(e) {
          e.preventDefault();
          _this2.onSearch([]);
        },
        className: __WEBPACK_IMPORTED_MODULE_26__styles_css___default.a.search
      }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_10_components_Search__["a" /* default */], {
        className: __WEBPACK_IMPORTED_MODULE_26__styles_css___default.a.searchInput,
        suggestions: this.suggest.bind(this),
        placeholder: 'Skriv in den aktivitet/det intresse du letar efter',
        onChange: this.onSearch.bind(this),
        keyFunc: function keyFunc(x) {
          return x.id;
        }
      }), _jsx(__WEBPACK_IMPORTED_MODULE_11_components_Button__["a" /* default */], {
        className: __WEBPACK_IMPORTED_MODULE_26__styles_css___default.a.searchButton
      }, void 0, 'S\xF6k')), _jsx('div', {
        style: { textAlign: 'center' }
      }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_24_components_Link__["a" /* default */], {
        label: 'Se alla aktiviteter',
        href: Object(__WEBPACK_IMPORTED_MODULE_15_utilities_routes__["c" /* reverse */])(__WEBPACK_IMPORTED_MODULE_25_views_ActivitiesAndSchools_constants__["a" /* NAME */]),
        exceptRole: 'hoppsan',
        className: __WEBPACK_IMPORTED_MODULE_26__styles_css___default.a.link
      })))), _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_26__styles_css___default.a.boxes
      }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_7_layouts_Container__["a" /* default */], {
        size: 'large'
      }, void 0, _ref4, _jsx(__WEBPACK_IMPORTED_MODULE_8_layouts_Distribute__["a" /* default */], {
        equalHeight: true
      }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_9_layouts_Box__["b" /* default */], {
        shadow: true
      }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_9_layouts_Box__["a" /* BoxSection */], {}, void 0, _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(__WEBPACK_IMPORTED_MODULE_26__styles_css___default.a.uspIcon, __WEBPACK_IMPORTED_MODULE_26__styles_css___default.a.green)
      }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_4__fortawesome_react_fontawesome___default.a, {
        icon: ['far', 'life-ring']
      })), _jsx(__WEBPACK_IMPORTED_MODULE_0_djedi_react__["Node"], {
        uri: 'home/pitch-box-1.md'
      }, void 0, Object(__WEBPACK_IMPORTED_MODULE_0_djedi_react__["md"])(_templateObject)))), _jsx(__WEBPACK_IMPORTED_MODULE_9_layouts_Box__["b" /* default */], {
        shadow: true
      }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_9_layouts_Box__["a" /* BoxSection */], {}, void 0, _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(__WEBPACK_IMPORTED_MODULE_26__styles_css___default.a.uspIcon, __WEBPACK_IMPORTED_MODULE_26__styles_css___default.a.blue)
      }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_4__fortawesome_react_fontawesome___default.a, {
        icon: ['far', 'heart']
      })), _jsx(__WEBPACK_IMPORTED_MODULE_0_djedi_react__["Node"], {
        uri: 'home/pitch-box-2.md'
      }, void 0, Object(__WEBPACK_IMPORTED_MODULE_0_djedi_react__["md"])(_templateObject2)))), _jsx(__WEBPACK_IMPORTED_MODULE_9_layouts_Box__["b" /* default */], {
        shadow: true
      }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_9_layouts_Box__["a" /* BoxSection */], {}, void 0, _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(__WEBPACK_IMPORTED_MODULE_26__styles_css___default.a.uspIcon, __WEBPACK_IMPORTED_MODULE_26__styles_css___default.a.orange)
      }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_4__fortawesome_react_fontawesome___default.a, {
        icon: ['far', 'calendar-check']
      })), _jsx(__WEBPACK_IMPORTED_MODULE_0_djedi_react__["Node"], {
        uri: 'home/pitch-box-3.md'
      }, void 0, Object(__WEBPACK_IMPORTED_MODULE_0_djedi_react__["md"])(_templateObject3))))), _jsx('p', {
        className: __WEBPACK_IMPORTED_MODULE_26__styles_css___default.a.spacer
      }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_11_components_Button__["a" /* default */], {
        rounded: true,
        onClick: function onClick() {
          return _this2.onSearch([]);
        }
      }, void 0, 'S\xF6k')))), _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_26__styles_css___default.a.storyWrapper
      }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_7_layouts_Container__["a" /* default */], {
        size: 'medium'
      }, void 0, _ref5, _jsx(__WEBPACK_IMPORTED_MODULE_12_components_StoryCarousel__["a" /* default */], {
        stories: [{
          picture: __WEBPACK_IMPORTED_MODULE_23_assets_homepage_foralder_susanne_stockholm_jpg___default.a,
          story: _jsx(__WEBPACK_IMPORTED_MODULE_0_djedi_react__["Node"], {
            uri: 'home/stories/parent1.md'
          }, void 0, Object(__WEBPACK_IMPORTED_MODULE_0_djedi_react__["md"])(_templateObject4))
        }, {
          picture: __WEBPACK_IMPORTED_MODULE_21_assets_homepage_foralder_karin_stockholm_jpg___default.a,
          story: _jsx(__WEBPACK_IMPORTED_MODULE_0_djedi_react__["Node"], {
            uri: 'home/stories/parent2.md'
          }, void 0, Object(__WEBPACK_IMPORTED_MODULE_0_djedi_react__["md"])(_templateObject5))
        }, {
          picture: __WEBPACK_IMPORTED_MODULE_22_assets_homepage_foralder_malin_stockholm_jpg___default.a,
          story: _jsx(__WEBPACK_IMPORTED_MODULE_0_djedi_react__["Node"], {
            uri: 'home/stories/parent3.md'
          }, void 0, Object(__WEBPACK_IMPORTED_MODULE_0_djedi_react__["md"])(_templateObject6))
        }]
      }))), _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_26__styles_css___default.a.boxes
      }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_7_layouts_Container__["a" /* default */], {
        size: 'large'
      }, void 0, _ref6, _jsx(__WEBPACK_IMPORTED_MODULE_8_layouts_Distribute__["a" /* default */], {
        equalHeight: true
      }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_9_layouts_Box__["b" /* default */], {
        shadow: true
      }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_9_layouts_Box__["a" /* BoxSection */], {
        className: __WEBPACK_IMPORTED_MODULE_26__styles_css___default.a.compactBox
      }, void 0, _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_26__styles_css___default.a.imageWrapper
      }, void 0, _jsx('img', {
        src: __WEBPACK_IMPORTED_MODULE_17_assets_homepage_student_lydia_jpg___default.a,
        className: __WEBPACK_IMPORTED_MODULE_26__styles_css___default.a.boxImage,
        alt: ''
      })), _jsx(__WEBPACK_IMPORTED_MODULE_0_djedi_react__["Node"], {
        uri: 'home/leader-boxes/person1.md'
      }, void 0, Object(__WEBPACK_IMPORTED_MODULE_0_djedi_react__["md"])(_templateObject7)))), _jsx(__WEBPACK_IMPORTED_MODULE_9_layouts_Box__["b" /* default */], {
        shadow: true
      }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_9_layouts_Box__["a" /* BoxSection */], {
        className: __WEBPACK_IMPORTED_MODULE_26__styles_css___default.a.compactBox
      }, void 0, _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_26__styles_css___default.a.imageWrapper
      }, void 0, _jsx('img', {
        src: __WEBPACK_IMPORTED_MODULE_18_assets_homepage_student_emil_jpg___default.a,
        className: __WEBPACK_IMPORTED_MODULE_26__styles_css___default.a.boxImage,
        alt: ''
      })), _jsx(__WEBPACK_IMPORTED_MODULE_0_djedi_react__["Node"], {
        uri: 'home/leader-boxes/person2.md'
      }, void 0, Object(__WEBPACK_IMPORTED_MODULE_0_djedi_react__["md"])(_templateObject8)))), _jsx(__WEBPACK_IMPORTED_MODULE_9_layouts_Box__["b" /* default */], {
        shadow: true
      }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_9_layouts_Box__["a" /* BoxSection */], {
        className: __WEBPACK_IMPORTED_MODULE_26__styles_css___default.a.compactBox
      }, void 0, _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_26__styles_css___default.a.imageWrapper
      }, void 0, _jsx('img', {
        src: __WEBPACK_IMPORTED_MODULE_19_assets_homepage_student_leonie_jpg___default.a,
        className: __WEBPACK_IMPORTED_MODULE_26__styles_css___default.a.boxImage,
        alt: ''
      })), _jsx(__WEBPACK_IMPORTED_MODULE_0_djedi_react__["Node"], {
        uri: 'home/leader-boxes/person3.md'
      }, void 0, Object(__WEBPACK_IMPORTED_MODULE_0_djedi_react__["md"])(_templateObject9)))), _jsx(__WEBPACK_IMPORTED_MODULE_9_layouts_Box__["b" /* default */], {
        shadow: true
      }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_9_layouts_Box__["a" /* BoxSection */], {
        className: __WEBPACK_IMPORTED_MODULE_26__styles_css___default.a.compactBox
      }, void 0, _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_26__styles_css___default.a.imageWrapper
      }, void 0, _jsx('img', {
        src: __WEBPACK_IMPORTED_MODULE_20_assets_homepage_student_sara_jpg___default.a,
        className: __WEBPACK_IMPORTED_MODULE_26__styles_css___default.a.boxImage,
        alt: ''
      })), _jsx(__WEBPACK_IMPORTED_MODULE_0_djedi_react__["Node"], {
        uri: 'home/leader-boxes/person4.md'
      }, void 0, Object(__WEBPACK_IMPORTED_MODULE_0_djedi_react__["md"])(_templateObject10))))))), _ref7);
    }
  }]);

  return HomePage;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

/* harmony default export */ __webpack_exports__["default"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["connect"])()(HomePage));

/***/ })

});


// WEBPACK FOOTER //
// views/Home-index.1f1181cf80fefc50384b.js